var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "수급업체 순회점검 기본정보" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.patrol.saiPatrolVendorId &&
                                  !_vm.disabled &&
                                  _vm.editable,
                                expression:
                                  "patrol.saiPatrolVendorId && !disabled && editable",
                              },
                            ],
                            attrs: {
                              url: _vm.completeUrl,
                              isSubmit: _vm.isComplete,
                              param: _vm.patrol,
                              mappingType: "PUT",
                              label: "LBLCOMPLETE",
                              icon: "check",
                            },
                            on: {
                              beforeAction: _vm.completePlan,
                              btnCallback: _vm.completeCallback,
                            },
                          }),
                          _vm.patrol.saiPatrolVendorId &&
                          !_vm.disabled &&
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  label: "LBLREMOVE",
                                  icon: "delete_forever",
                                },
                                on: { btnClicked: _vm.remove },
                              })
                            : _vm._e(),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.disabled && _vm.editable,
                                expression: "!disabled && editable",
                              },
                            ],
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.patrol,
                              mappingType: _vm.saveType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.savePlan,
                              btnCallback: _vm.saveCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable:
                              _vm.editable && !_vm.patrol.saiPatrolVendorId,
                            type: "edit",
                            name: "plantCd",
                          },
                          on: { datachange: _vm.datachange },
                          model: {
                            value: _vm.patrol.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "plantCd", $$v)
                            },
                            expression: "patrol.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "순회일",
                            type: "date",
                            name: "patrolDate",
                          },
                          model: {
                            value: _vm.patrol.patrolDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "patrolDate", $$v)
                            },
                            expression: "patrol.patrolDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-vendor", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            selfFlag: false,
                            label: "협력업체",
                            name: "vendorCd",
                          },
                          model: {
                            value: _vm.patrol.vendorCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "vendorCd", $$v)
                            },
                            expression: "patrol.vendorCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            data: _vm.patrol,
                            deptValue: "partolDeptCd",
                            type: "dept_user",
                            label: "점검자/부서",
                            name: "patrolUserId",
                          },
                          model: {
                            value: _vm.patrol.patrolUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "patrolUserId", $$v)
                            },
                            expression: "patrol.patrolUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "순회명",
                            name: "patrolName",
                          },
                          model: {
                            value: _vm.patrol.patrolName,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "patrolName", $$v)
                            },
                            expression: "patrol.patrolName",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-table",
                {
                  ref: "grid",
                  attrs: {
                    title: "항목별 결과 목록",
                    columns: _vm.grid.columns,
                    gridHeight: _vm.grid.height,
                    data: _vm.patrol.patrolVendorResultModelList,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    noDataLabel: "항목별 결과 추가하세요.",
                    hideBottom: true,
                    editable: _vm.editable && !_vm.disabled,
                    rowKey: "saiPatrolVendorResultId",
                    selection: "multiple",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "customCol"
                            ? [
                                _c(_vm.imprComponent, {
                                  tag: "component",
                                  attrs: {
                                    col: col,
                                    props: props,
                                    inputEditable:
                                      _vm.editable && !_vm.disabled,
                                    isImmShow: false,
                                    vendorCd: _vm.patrol.vendorCd,
                                    requestContentsCols:
                                      _vm.requestContentsCols,
                                    tableKey: "saiPatrolVendorResultId",
                                    ibmTaskTypeCd: "ITT0000066",
                                    ibmTaskUnderTypeCd: "ITTU000115",
                                  },
                                  on: { imprChange: _vm.imprChange },
                                }),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLADD",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addResult },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.patrol.patrolVendorResultModelList.length > 0
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLEXCEPT",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeResult },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "순회결과 정보", collapsed: true },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            codeGroupCd: "PATROL_VENDOR_RESULT_CD",
                            editable: _vm.editable,
                            type: "edit",
                            disabled: _vm.disabled,
                            itemText: "codeName",
                            itemValue: "code",
                            name: "patrolResultCd",
                            label: "순회결과",
                          },
                          model: {
                            value: _vm.patrol.patrolResultCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "patrolResultCd", $$v)
                            },
                            expression: "patrol.patrolResultCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            rows: 4,
                            label: "순회결과요약",
                            name: "patrolResultSummary",
                          },
                          model: {
                            value: _vm.patrol.patrolResultSummary,
                            callback: function ($$v) {
                              _vm.$set(_vm.patrol, "patrolResultSummary", $$v)
                            },
                            expression: "patrol.patrolResultSummary",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "관련파일", collapsed: true },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-upload", {
                          attrs: {
                            attachInfo: _vm.attachInfo,
                            editable: _vm.editable && !_vm.disabled,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }